/* eslint-disable react/react-in-jsx-scope */
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import type { Entity } from '@backstage/catalog-model';
import { useAsync } from 'react-use';
import {
  ENTITY_PICKER_CATALOG_FILTER,
  ENTITY_PICKER_FULL_TEXT_FIELDS,
  rankEntitySearchResults,
} from './entityPickerSearch';

/**
 * Catalog entities matching a full-text search (min 2 characters — caller should
 * gate on that for empty vs loading UX).
 */
export function useCatalogEntitySearch(search: string) {
  const catalogApi = useApi(catalogApiRef);
  const q = search.trim();

  return useAsync(async () => {
    if (q.length < 2) {
      return [] as Entity[];
    }
    const res = await catalogApi.queryEntities({
      filter: ENTITY_PICKER_CATALOG_FILTER,
      limit: 100,
      orderFields: [{ field: 'metadata.name', order: 'asc' }],
      fullTextFilter: {
        term: q,
        fields: [...ENTITY_PICKER_FULL_TEXT_FIELDS],
      },
    });
    return rankEntitySearchResults(res.items, q);
  }, [q, catalogApi]);
}
